export default {
  // Meta & Header
  siteTitle: 'CSSBuy Spreadsheet 2026 | Guides, Products, QC & Shipping',
  siteDescription: 'Explore the CSSBuy Spreadsheet with product research guides, QC tips, shipping information, comparisons, safety resources and practical buying guides.',
  navHome: 'Home',
  navShoppingGuide: 'Shopping Guide',
  navSpreadsheet: 'CSSBuy Spreadsheet',
  navReview: 'Review',
  navShipping: 'Shipping',
  navGuide: 'Guide',
  navSafety: 'Safety',
  navFAQ: 'FAQ',
  navCategories: 'Categories',
  navDropdownCategories: 'Product Categories',
  navEnglish: 'English',
  navGerman: 'Deutsch',
  navPortuguese: 'Português',
  navOpen: 'Open menu',
  navClose: 'Close menu',

  // Hero Section
  heroH1: 'CSSBuy Spreadsheet: Find, Compare & Research Better',
  heroSubtitle: 'Explore the CSSBuy Spreadsheet to research products, compare options, and better understand QC, storage, shipping, and other important points before buying.',
  heroCtaPrimary: 'Explore CSSBuy Spreadsheet',
  heroCtaSecondary: 'View CSSBuy Guide',
  heroTrust: 'Updated in 2026 · Practical Guides · QC · Shipping · Comparisons · Safety',

  // What is CSSBuy Spreadsheet
  whatIsH2: 'What is the CSSBuy Spreadsheet?',
  whatIsText: 'The CSSBuy Spreadsheet is an organized resource for product research. Explore categories, compare options, and consult guides on QC, prices, storage, and shipping to make more informed decisions.',
  whatIsCta: 'View CSSBuy Spreadsheet',

  // Benefits
  benefitsH2: 'Research better before buying',
  benefit1Title: 'Organized Research',
  benefit1Text: 'Find categories and relevant information in one place.',
  benefit2Title: 'Compare Options',
  benefit2Text: 'Compare products, methods, and alternatives before deciding.',
  benefit3Title: 'Practical Guides',
  benefit3Text: 'Learn about QC, warehouse, shipping, and costs.',
  benefit4Title: 'More Safety',
  benefit4Text: 'Check important recommendations in the Safety Center.',

  // Categories
  categoriesH2: 'Explore Popular Categories',
  categoriesCta: 'Explore All Categories',
  catShoes: 'Shoes',
  catHoodies: 'Hoodies/Sweaters',
  catTshirts: 'T-Shirts',
  catJackets: 'Jackets',
  catPants: 'Pants/Shorts',
  catHeadwear: 'Headwear',
  catSets: 'Sets',
  catUnderwear: 'Underwear/Underpants',
  catJersey: 'Jersey',
  catAccessories: 'Accessories',
  catBags: 'Bags',
  catBelts: 'Belts',
  catPerfumes: 'Perfumes',
  catOther: 'Other Stuff',

  // How It Works
  howItWorksH2: 'How to use the CSSBuy Spreadsheet',
  step1: 'Choose a category',
  step2: 'Research products',
  step3: 'Compare information',
  step4: 'Check QC',
  step5: 'Read the related guide',
  step6: 'Continue your research on the main site',
  howItWorksNote: 'Prices, availability, policies, and shipping options may change. Always confirm current information before buying.',

  // Review Section
  reviewH2: 'CSSBuy Review: What you need to know',
  reviewText: 'Check our analysis of features, QC, warehouse, shipping, costs, and important points for beginners.',
  reviewCta: 'Read CSSBuy Review',

  // Shipping Section
  shippingH2: 'CSSBuy Shipping Cost: Understand the total cost',
  shippingText: 'Shipping costs may vary depending on weight, dimensions, destination, and chosen method. See our guide to understand the main factors that influence cost.',
  shippingCta: 'View Shipping Guide',

  // Safety Section
  safetyH2: 'Research with more safety',
  safetyText: 'Verify URLs, product information, QC, payments, and policies before making any transaction. Never share passwords or confidential information.',
  safetyCta: 'Open Safety Center',
  safetyCheckUrl: 'Check URL',
  safetyProtectPassword: 'Protect password',
  safetyVerifyPayment: 'Verify payment',
  safetyReviewQC: 'Review QC',
  safetyCheckShipping: 'Check shipping',
  safetyKeepRecords: 'Keep records',

  // Final CTA
  finalCtaH2: 'Ready to start your research?',
  finalCtaText: 'Explore the CSSBuy Spreadsheet and find guides, categories, comparisons, and resources to better organize your research.',
  finalCtaButton: 'Explore CSSBuy Spreadsheet',

  // Articles Preview
  articlesH2: 'Recent Articles & Guides',
  articlesSubtitle: 'Complete guides and original articles on product research, QC, shipping, and safety.',
  articlesCta: 'View All Articles',
  article1Title: 'CSSBuy Spreadsheet 2026: Complete Guide',
  article1Desc: 'Discover how to use the CSSBuy Spreadsheet to research products in an organized and efficient way.',
  article2Title: 'CSSBuy Shipping Guide: Everything about shipping',
  article2Desc: 'Understand shipping methods, costs, timelines, and how to choose the best option.',
  article3Title: 'CSSBuy QC Guide: Quality verification',
  article3Desc: 'Learn how to analyze QC photos and verify product quality before shipping.',

  // FAQ
  faqH2: 'Frequently Asked Questions',
  faq1Q: 'What is the CSSBuy Spreadsheet?',
  faq1A: 'The CSSBuy Spreadsheet is an organized resource that helps with product research, comparison of options, and consultation of guides on QC, prices, storage, and shipping.',
  faq2Q: 'Is CSSBuy safe?',
  faq2A: 'Safety depends on how you use the service. Follow our recommendations in the Safety Center, verify URLs, protect your passwords, and always review QC before confirming shipments.',
  faq3Q: 'How does shipping work?',
  faq3A: 'Shipping costs vary depending on weight, dimensions, destination, and chosen method. Consult our complete guide to understand the factors that influence the total cost.',
  faq4Q: 'What categories are available?',
  faq4A: 'Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.',

  // Footer
  footerLinks: 'Useful Links',
  footerGuides: 'Guides',
  footerCategories: 'Categories',
  footerLegal: 'Legal',
  footerAbout: 'About',
  footerContact: 'Contact',
  footerDisclaimer: 'Disclaimer',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Use',
  footerEditorial: 'Editorial Policy',
  footerSpreadsheet: 'CSSBuy Spreadsheet',
  footerReview: 'CSSBuy Review',
  footerShippingGuide: 'Shipping Guide',
  footerQCGuide: 'QC Guide',
  footerCouponGuide: 'Coupon Guide',
  footerWarehouseGuide: 'Warehouse Guide',
  footerCopyright: '© 2026 CSSBuy Spreadsheet. All rights reserved.',
  footerDisclaimerText: 'This website is an independent informational resource. It does not guarantee products, sellers, prices, shipping services, refunds, or third-party transactions.',

  // Buttons
  btnMainSite: 'CSSBuy Spreadsheet',
  btnBuyNow: 'Buy It Now',
  btnReadMore: 'Read more',
  btnExplore: 'Explore',
  btnLearnMore: 'Learn more',

  // Disclaimer
  infoDisclaimer: 'Information may change. Verify current details before ordering.',

  // Table headers
  tableFeature: 'Feature',
  tableCssbuy: 'CSSBuy',
  tableSuperbuy: 'Superbuy',
  tableSugargoo: 'Sugargoo',
  tableCheck: 'Check',
  tableCompare: 'Compare',

  // Breadcrumbs
  breadcrumbHome: 'Home',
  breadcrumbSpreadsheet: 'CSSBuy Spreadsheet',
  breadcrumbReview: 'Review',
  breadcrumbShipping: 'Shipping',
  breadcrumbGuide: 'Guide',
  breadcrumbSafety: 'Safety',
  breadcrumbFAQ: 'FAQ',
  breadcrumbCategories: 'Categories',
  breadcrumbArticles: 'Articles',

  // Comparison page
  comparisonH1: 'CSSBuy vs Alternatives: Complete Comparison',
  comparisonIntro: 'Compare CSSBuy with other buying agents to find the best option for your needs.',
  comparisonProductResearch: 'Product Research',
  comparisonQC: 'QC',
  comparisonWarehouse: 'Warehouse',
  comparisonShipping: 'Shipping',
  comparisonBeginnerFriendly: 'Beginner Friendly',
  comparisonNote: 'Information may change. Verify current details before ordering.',

  // Shipping page
  shippingH1: 'CSSBuy Shipping Cost: Complete Guide',
  shippingIntro: 'Understand all the factors that influence CSSBuy shipping costs.',
  shippingFactorWeight: 'Package weight',
  shippingFactorDimensions: 'Dimensions',
  shippingFactorDestination: 'Destination',
  shippingFactorMethod: 'Shipping method',
  shippingFactorInsurance: 'Insurance (optional)',

  // QC Page
  qcH1: 'CSSBuy QC Guide: Quality Verification',
  qcIntro: 'Learn how to analyze QC photos and verify product quality before shipping.',
  qcStep1: 'Check detailed photos',
  qcStep2: 'Compare with seller photos',
  qcStep3: 'Inspect stitching and materials',
  qcStep4: 'Check logos and labels',
  qcStep5: 'Confirm sizes and measurements',

  // Safety page
  safetyH1: 'CSSBuy Safety Center: Research Safely',
  safetyIntro: 'Important recommendations to protect your information and transactions.',
  safetyUrlVerify: 'URL Verification',
  safetyUrlVerifyText: 'Always verify that the site is official before logging in or making payments.',
  safetyPassword: 'Password Protection',
  safetyPasswordText: 'Never share your passwords. Use unique passwords and two-factor authentication.',
  safetyPayment: 'Payment Safety',
  safetyPaymentText: 'Verify secure payment methods and confirm URLs before transactions.',
  safetyProductInfo: 'Product Information',
  safetyProductInfoText: 'Verify product details, QC, and photos before confirming purchases.',
  safetyCustoms: 'Customs',
  safetyCustomsText: 'Understand the customs rules of your country before shipping.',
  safetyRecords: 'Transaction Records',
  safetyRecordsText: 'Keep records of all orders, payments, and shipments.',

  // Guide page
  guideH1: 'CSSBuy Guide: Complete Beginner Guide',
  guideIntro: 'Everything you need to know to start using CSSBuy safely and efficiently.',
  guideStep1Title: 'Create your account',
  guideStep1Text: 'Register on the official website and set up your account with correct information.',
  guideStep2Title: 'Research products',
  guideStep2Text: 'Use the CSSBuy Spreadsheet to find and organize your research.',
  guideStep3Title: 'Check QC',
  guideStep3Text: 'Analyze quality photos before approving the shipment.',
  guideStep4Title: 'Choose shipping',
  guideStep4Text: 'Select the appropriate shipping method for your destination and budget.',
  guideStep5Title: 'Track your order',
  guideStep5Text: 'Monitor the shipment status until final delivery.',

  // Spreadsheet page
  spreadsheetH1: 'CSSBuy Spreadsheet: Complete Research Resource',
  spreadsheetIntro: 'The CSSBuy Spreadsheet is the central tool for organizing and comparing your product research.',
  spreadsheetFeature1: 'Organized categories',
  spreadsheetFeature2: 'Product comparisons',
  spreadsheetFeature3: 'QC information',
  spreadsheetFeature4: 'Shipping guides',
  spreadsheetFeature5: 'Safety tips',
  spreadsheetFeature6: 'Regular updates',
  spreadsheetCta: 'Explore Now',

  // Review page
  reviewH1: 'CSSBuy Review 2026: Complete Analysis',
  reviewIntro: 'Detailed analysis of features, services, and important points of CSSBuy.',
  reviewPros: 'Positive Points',
  reviewCons: 'Points to Consider',
  reviewPro1: 'Organized interface for research',
  reviewPro2: 'Multiple shipping options',
  reviewPro3: 'QC system for verification',
  reviewPro4: 'Warehouse for storage',
  reviewCon1: 'Shipping cost can vary greatly',
  reviewCon2: 'Timelines depend on chosen method',
  reviewCon3: 'Policies may change without notice',
  reviewCon4: 'Need to verify current information',

  // Article page
  articlePublished: 'Published',
  articleUpdated: 'Updated',
  articleReadTime: 'min read',
  articleRelated: 'Related Articles',
  articleTldr: 'TL;DR',
  articleContents: 'Contents',
  articleTips: 'Important Tips',
  articleSafety: 'Safety',
  articleFaq: 'FAQ',

  // Beginners article
  beginnersH1: 'CSSBuy Spreadsheet for Beginners: Step-by-Step Guide',
  beginnersIntro: 'This complete guide teaches how to use the CSSBuy Spreadsheet to research products in an organized and efficient way.',
  beginnersSection1H2: 'What is the CSSBuy Spreadsheet?',
  beginnersSection1Text: 'The CSSBuy Spreadsheet is an organized tool that allows you to research products, compare options, and consult information about QC, shipping, warehouse, and costs in one place.',
  beginnersSection2H2: 'How to get started',
  beginnersSection2Text: 'To start, familiarize yourself with the available categories. Each category contains organized information about relevant products. Use the categories menu to navigate between Shoes, Hoodies, T-Shirts, Jackets, and other options.',
  beginnersSection3H2: 'How to research products',
  beginnersSection3Text: 'Product research in the CSSBuy Spreadsheet is intuitive. Choose a category, explore available options, and compare different products before making a decision. Always verify updated information before buying.',
  beginnersSection4H2: 'Tips for beginners',
  beginnersSection4Text: 'Always check QC before approving shipments. Compare prices and shipping methods. Keep records of all transactions. Use the Safety Center to check important recommendations.',
  beginnersSection5H2: 'Comparison: CSSBuy vs Alternatives',
  beginnersSection5Text: 'When comparing CSSBuy with other options, consider factors such as product research, QC, warehouse, shipping, and ease of use for beginners.',

  // Common
  readMore: 'Read more',
  goToMainSite: 'Go to main site',
  search: 'Search',
  share: 'Share',
  close: 'Close',
  loading: 'Loading...',
  error: 'Error',
  retry: 'Try again',

  // Not Found
  notFoundTitle: 'Page not found',
  notFoundText: 'The page you are looking for does not exist.',
  notFoundCta: 'Back to home',
};